import { useEffect, useRef } from 'react';

export function useModalA11y(isOpen, onClose, titleId) {
    const modalRef = useRef(null);
    const triggerRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return;

        triggerRef.current = document.activeElement;
        
        // Bloqueio do scroll do body enquanto aberto
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const node = modalRef.current;
        const focusable = node
            ? node.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
            : [];
        
        if (focusable.length > 0) {
            focusable[0].focus();
        }

        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                if (onClose) onClose();
                return;
            }
            if (e.key !== 'Tab' || focusable.length === 0) return;
            
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            
            if (e.shiftKey && document.activeElement === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        };
        
        document.addEventListener('keydown', handleKeyDown);
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = originalOverflow;
            triggerRef.current?.focus?.();
        };
    }, [isOpen, onClose]);

    return {
        ref: modalRef,
        role: 'dialog',
        'aria-modal': 'true',
        ...(titleId ? { 'aria-labelledby': titleId } : {}),
    };
}
